import axios from 'axios';
import { eventBus } from '@/utils/event';
import { sendSMS } from '@/api/sms.js';

const showLog = localStorage.show_log === '1';
const appids = {
	'dev': '1692d9cb170b471093e4922d67402264',
	'pre': '1692d9cb170b471093e4922d67402264',
	'online': '1692d9cb170b471093e4922d67401163'
};
const instance = axios.create({
  timeout: 30000,
  headers: {
  	'App-Id': localStorage.debug_appid || appids[process.env.VUE_APP_ENVIRONMENT],
  	'M-Device-Type': 'mobile_web',
  	'M-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
  }
});

export function network(opts) {
	const { method, params = {}, url, headers = {} } = opts;
	
	if (method === 'post') {
		return new Promise((resolve, reject) => {
			instance.post(url, {
			  ...params
			}, {
				headers
			}).then((res) => {
				const body = res.data;

				if (body.code === 10001) {
					eventBus.$emit('relogin');
				}

				resolve(body);
			}).catch((err) => {
				// try {
				// 	sendSMS({
	   //        content: `接口${url}调用失败，错误信息:${JSON.stringify(err)}`
	   //      });
				// }
				// catch(e) {}

				if (err.response && err.response.status === 401) {
					reject({
						code: 1000,
						message: '登录过期，请重新登录'
					});
					eventBus.$emit('relogin');
					return;
				}

				if (err.response && err.response.status === 403) {
					reject({
						code: 1001,
						message: '无权限'
					});
					return;
				}

				if (err.response) {
					reject({
						code: 1002,
						message: err.response.statusText
					});
				}
				else {
					reject({
						code: 1002,
						message: err.message
					});
				}
			});
		});
	}

	if (method === 'get') {
		return new Promise((resolve, reject) => {
			instance.get(url, {
			  params,
			  headers
			}).then((res) => {
				const body = res.data;

				if (body.code === 10001) {
					eventBus.$emit('relogin');
				}

				resolve(body);
			}).catch((err) => {
				// try {
				// 	sendSMS({
	   //        content: `接口${url}调用失败，错误信息:${JSON.stringify(err)}`
	   //      });
				// }
				// catch(e) {}

				if (err.response && err.response.status === 401) {
					reject({
						code: 1000,
						message: '登录过期，请重新登录'
					});
					eventBus.$emit('relogin');
					return;
				}

				if (err.response && err.response.status === 403) {
					reject({
						code: 1001,
						message: '无权限'
					});
					return;
				}

				if (err.response) {
					reject({
						code: 1002,
						message: err.response.statusText
					});
				}
				else {
					reject({
						code: 1002,
						message: err.message
					});
				}
			});
		});
	}
}
